/* eslint-disable max-len */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageAssayColumn } from '.';

export interface ManageAssayTableHeadProps {
  columns: ManageAssayColumn[];
};

export const ManageAssayTableHead = memo((props: ManageAssayTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth, textAlign: col.align }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
});

ManageAssayTableHead.displayName = 'ManageAssayTableHead';
